import React from 'react';
import { HashRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import HomePage from './pages/HomePage';
import About from './pages/About';
import Services from './pages/Services';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import ContactDetailPage from './pages/ContactDetailPage';
// import Careers from './pages/Careers';
import Contact from './pages/Contact';
import NewsPage from './pages/newsPage';
import Qr from './pages/Qr';
import NotFound from './pages/NotFound'; // Import the new 404 page

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/news/:newsTitle" element={<NewsPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:projectTitle" element={<ProjectDetailPage />} />
        {/* <Route path="/contacts/:contactTitle" element={<ContactDetailPage />} /> */}
        {/* <Route path="/careers" element={<Careers />} /> */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/qr" element={<Qr />} />
        {/* Catch-all route for 404 */}
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
